import { useContext, useState } from "react";
import EmailStepForm from "../../CreateAccount/EmailStepForm";
import { AccountInfoContext } from "./AccountInfoContext";
import AccountLoginStep from "./AccountLoginStep";

/**
 * A component for the email step in the account info step of the booking.
 *
 * It is simply a wrapper around the EmailStepForm component that provides it with the necessary values from the context
 *
 * @returns {JSX.Element}
 */

const AccountInfoEmailStep = () => {
  const { firstStepSubmit, existEmail, setExistEmail, } = useContext(AccountInfoContext);
  const [tempEmail, setTempEmail] = useState("");
  const initialValues = {
    email: "",
  };
  return (
    <>
    {!existEmail ? 
    <EmailStepForm initialValues={initialValues} onSubmitSuccess={firstStepSubmit} setExistEmail={setExistEmail} setTempEmail={setTempEmail}/>
    : 
    <AccountLoginStep setExistEmail={setExistEmail} email={tempEmail}/>
    }
    
    </>
  );
};

export default AccountInfoEmailStep;
